import React from 'react';

import { FileLayout, FileName, FileNameLayout, StyledSmallDownload, Thumbnail } from './styles';
import { FileWithPreviewProps } from './types';
import Item from '../Item';

const FileWithPreview: React.FunctionComponent<FileWithPreviewProps> = ({
  activity,
  onDeleteFile,
  downloadFile,
  sessionUser,
}) => {
  const isCurrentUserAuthor = activity?.creator?.uuid === sessionUser.uuid;
  return (
    <Item activity={activity} onDeleteItem={onDeleteFile} sessionUser={sessionUser}>
      <FileLayout>
        {activity.thumbnail && (
          <Thumbnail
            src={activity.thumbnail}
            onClick={downloadFile ? () => downloadFile(activity.file)() : undefined}
            $clickable={Boolean(downloadFile)}
          />
        )}
        <FileNameLayout>
          <FileName id="activity-file-thumbnail-name" isAuthor={isCurrentUserAuthor}>
            {activity.filename}
          </FileName>
          {downloadFile && (
            <StyledSmallDownload onClick={() => downloadFile(activity.file)()} isAuthor={isCurrentUserAuthor} />
          )}
        </FileNameLayout>
      </FileLayout>
    </Item>
  );
};

export default FileWithPreview;
